import axios from "axios";
import { doLogout } from "../utils/doLogout";
import { useAlertStore } from "../store/alertStore";
import config from "../config";

let isRefreshing = false; // 현재 리프레시 요청 중인지 상태

const apiClient = axios.create({
  baseURL: config.api.url,
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
    "x-site": process.env.REACT_APP_X_SITE,
  },
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token && config.url !== "/members/login") {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

apiClient.interceptors.response.use(
  (response) => {
    if (config.isDev) {
      console.log("response:", response);
    }
    return response;
  },
  async (error: any) => {
    if (config.isDev) {
      console.error(error);
    }
    const originalRequest = error.config;
    const statusCode = error.response.data.statusCode;
    const message = error.response.data.message;

    if (statusCode === 403) {
      // alert("세션이 만료되었습니다.");
      // doLogout();
      // return Promise.reject(error);
    }

    if (statusCode === 461) {
      if (isRefreshing) {
        // useAlertStore.getState().setAlert(message, "red");
        return Promise.reject(error);
      }

      isRefreshing = true;
      try {
        const refreshToken = localStorage.getItem("refreshToken");

        if (!refreshToken) {
          alert("세션이 만료되었습니다.");
          doLogout();
          return Promise.reject(error);
        }

        const res = await axios.post(`${config.api.url}/members/refresh`, {
          refresh_token: refreshToken,
        });

        const newAccessToken = res.data.data.access_token;
        const newRefreshToken = res.data.data.refresh_token;

        // 로컬스토리지에 새 토큰 저장
        localStorage.setItem("token", newAccessToken);
        if (newRefreshToken) {
          localStorage.setItem("refreshToken", newRefreshToken);
        }

        // 원래 요청의 헤더에 새 토큰 적용 후 재시도
        if (originalRequest.headers) {
          originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
        }
        return apiClient(originalRequest);
      } catch (error: any) {
        // 재발급 실패 => 완전히 로그아웃
        alert("세션이 만료되었습니다.");
        doLogout();
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    } else {
      useAlertStore.getState().setAlert(message, "red");
    }

    return Promise.reject(error);
  }
);

export default apiClient;